export function toFixedWithPrecision(num:number,precision:number){
	let base = 10 ** precision;
	return (Math.round(num * base) / base).toFixed(precision);
}